// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Linkedproject,
  LinkedprojectFromJSON,
  LinkedprojectToJSON,
  LinkedprojectPayload,
  LinkedprojectPayloadFromJSON,
  LinkedprojectPayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface CreateLinkedProjectRequest {
  linkedprojectPayload?: LinkedprojectPayload;
}

export interface GetLinkedProjectsRequest {
  company: number;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

/**
 * no description
 */
export class LinkedprojectsApi extends runtime.BaseAPI {
  /**
   * Payment Profile to add
   * Create a new linked project
   */
  async createLinkedProjectRaw(
    requestParameters: CreateLinkedProjectRequest
  ): Promise<runtime.ApiResponse<Linkedproject>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/linkedprojects`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: LinkedprojectPayloadToJSON(requestParameters.linkedprojectPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      LinkedprojectFromJSON(jsonValue)
    );
  }

  /**
   * Payment Profile to add
   * Create a new linked project
   */
  async createLinkedProject(
    requestParameters: CreateLinkedProjectRequest
  ): Promise<Linkedproject> {
    const response = await this.createLinkedProjectRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get list of linked projects
   * Get list of linked projects
   */
  async getLinkedProjectsRaw(
    requestParameters: GetLinkedProjectsRequest
  ): Promise<runtime.ApiResponse<Array<Linkedproject>>> {
    if (
      requestParameters.company === null ||
      requestParameters.company === undefined
    ) {
      throw new runtime.RequiredError(
        "company",
        "Required parameter requestParameters.company was null or undefined when calling getLinkedProjects."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.company !== undefined) {
      queryParameters["company"] = requestParameters.company;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/linkedprojects`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(LinkedprojectFromJSON)
    );
  }

  /**
   * Get list of linked projects
   * Get list of linked projects
   */
  async getLinkedProjects(
    requestParameters: GetLinkedProjectsRequest
  ): Promise<Array<Linkedproject>> {
    const response = await this.getLinkedProjectsRaw(requestParameters);
    return await response.value();
  }
}
